import { FunctionalComponent, h } from "preact";
import styles from "./style.css";
import { useEffect, useState } from "preact/hooks";
import { useAppSelector } from "../../redux/hooks";
import Controls from "./controls";
import {
  getSassToken,
  getPdfFileCache,
  getEdgeSassToken,
  getEdgeUserLoginSession,
} from "../../utils";
import { sendEvent } from "../stats/sendEvent";
import { IKorraEventDoc, IKorraEventType } from "../../models/interfaces";
import { isMobileOnly } from "react-device-detect";
import {
  get_AI_URI_BASE,
  get_APP_URI_BASE,
  get_CDN_BASE_URL,
  get_DASHBOARD_URI_BASE,
  get_IS_CDN77,
  getIsEdge,
  getCdnKorraBaseUrl,
} from "../../configs/env";
import { FileType } from "../../models/enums";
import {
  initFzMatrix,
  FzMatrix,
  FzRect,
  fz_transform_rect,
} from "./muPdfUtils";
import { removeMultipleSlashes, updateCdnUrlFromDotenv } from "../../utils";
import appearanceSlice from "src/redux/slices/appearanceSlice";
import PrerequisitesBox from "./prerequisites";
import { get } from "http";
import logger from "../../logger";

const axios = require("axios").default;

export interface IKorraPdfViewerProps {
  companyid: string;
  portalid?: string;
  kappid: string;
  workspaceAlias?: string;
  portalAlias?: string;
  docguid: string;
  page: string;
  guid: string;
  options?: any;
  mode?: string;
  fileRepositoryDestinationLink?: string;
  enableFileRepositoryDestinationLink?: boolean;
  highlight: boolean;
  userId?: string;
  chatbotFlag?: string;
  jwtUserIdToken?: string;
  select_text?: boolean;
  selectRef?: any;
  sasToken?: string;
}

interface Rect extends Array<number> {}

let _rawCanvases: any = {};
let _eventBus: any;

/**
 * PDF viewer
 * @param props
 * @returns
 */
const KorraPdfViewer: FunctionalComponent<IKorraPdfViewerProps> = (
  props: IKorraPdfViewerProps
) => {
  const [_notNeededCanvas, setCanvas] = useState<any>(null);
  const {
    companyid,
    portalid,
    kappid,
    workspaceAlias,
    portalAlias,
    docguid,
    page,
    guid,
    mode,
    options,
    fileRepositoryDestinationLink,
    enableFileRepositoryDestinationLink,
    highlight,
    userId,
    jwtUserIdToken,
    select_text,
    chatbotFlag,
    selectRef,
    sasToken,
  } = props;
  const [text, setText] = useState<any>(null);
  const [nextSectionGuid, setNextSectionGuid] = useState<any>(null);
  const PDFViewerApplication = (window as any).PDFViewerApplication;
  const [pdfSrcUrl, setPdfSrcUrl] = useState<any>(null);
  const [sectionDetails, setSectionDetails] = useState<any>(null);
  const [pageDetails, setPageDetails] = useState<any>(null);
  const [documentLoaded, setDocumentLoaded] = useState<any>(null);
  const [windowFullyLoaded, setWindowLoaded] = useState<boolean>(false);
  const [optionsObj, setOptionsObj] = useState<any>(null);
  const [documentLanguage, setDocumentLanguage] = useState<string>("en");
  const [prerequisitesQueries, setPrerequisitesQueries] = useState<string[]>(
    []
  );
  const [isEdge, setIsEdge] = useState(getIsEdge());
  const [prerequisitesConditions, setPrerequisitesConditions] = useState<
    string[]
  >([]);
  const appearance = useAppSelector((state) => state.appearance);
  const globals = useAppSelector((state) => state.globals);
  const alias = useAppSelector((state) => state.alias);
  const auth = useAppSelector((state) => state.auth);
  const fileName = decodeURIComponent(
    sectionDetails?.data[0]?._source?.srcUrl?.split("/").pop().split(".")[0]
  );

  const isArrayOfNumbers = (prop: any): boolean => {
    if (!Array.isArray(prop)) {
      return false; // not an array
    }
    return prop.every((element: any) => typeof element === "number");
  };

  // const prerequisites = [
  //   {text:'How to configure the amp limit?',link :"https://www.google.com/"},
  //   {text:'How to set up excessive current?',link:"www.google.com"},
  //   // {text:'What are the key steps to follow after setup?',link:"blablabla"},
  // ];

  /**
   *
   * @param nextSectionPageNumber
   */
  const calcNextRoute = (nextSectionPageNumber: number): string => {
    let nextRoute: string;
    if (workspaceAlias && portalAlias)
      nextRoute = `/${workspaceAlias}/${portalAlias}/kapp/${kappid}/pdf/docGuid/${docguid}/page/${nextSectionPageNumber}/guid/${nextSectionGuid}`;
    else if (portalid)
      nextRoute = `/workspace/${companyid}/portal/${portalid}/kapp/${kappid}/pdf/docGuid/${docguid}/page/${nextSectionPageNumber}/guid/${nextSectionGuid}`;
    else
      nextRoute = `/workspace/${companyid}/kapp/${kappid}/pdf/docGuid/${docguid}/page/${nextSectionPageNumber}/guid/${nextSectionGuid}`;

    return nextRoute;
  };

  const [playNow, setPlayNow] = useState(false);
  const [playNowFT, setPlayNowFT] = useState(true);

  /**
   * clone the canvas
   * @param oldCanvas
   * @returns
   */
  const cloneCanvas = (oldCanvas: any) => {
    //create a new canvas
    var newCanvas = document.createElement("canvas");
    var context = newCanvas.getContext("2d");

    //set dimensions
    newCanvas.width = oldCanvas.width;
    newCanvas.height = oldCanvas.height;

    //apply the old canvas to the new one
    context?.drawImage(oldCanvas, 0, 0);

    //return the new canvas
    return newCanvas;
  };

  /** convert bounding box to canvas coordinates */
  const pdfBoxToCanvas = (
    pdfWidth: number,
    pdfHeight: number,
    cropBox: Rect,
    mediaBox: Rect,
    boundingBox: Rect,
    canvasWidth: number,
    canvasHeight: number,
    tmx: number[]
  ): Array<number> => {
    cropBox = cropBox || [0, 0, pdfWidth, pdfHeight];
    mediaBox = mediaBox || [0, 0, pdfWidth, pdfHeight];
    let userBoxH = mediaBox[3] - mediaBox[1];
    let userBoxW = mediaBox[2] - mediaBox[0];
    let userBoxX = mediaBox[0];
    let userBoxY = mediaBox[1];

    // we only use mediaBox for now
    if (
      cropBox[0] !== mediaBox[0] ||
      cropBox[1] !== mediaBox[1] ||
      cropBox[2] !== mediaBox[2] ||
      cropBox[3] !== mediaBox[3]
    ) {
      // TODO: send email
      userBoxH = cropBox[3] - cropBox[1];
      userBoxW = cropBox[2] - cropBox[0];
      userBoxX = cropBox[0];
      userBoxY = cropBox[1];
    }

    var heightRatio = canvasHeight / userBoxH;
    var widthRatio = canvasWidth / userBoxW;

    let rect = null;
    if (!tmx) {
      let boxHeightInCanvasUnits =
        (boundingBox[3] - boundingBox[1]) * heightRatio;
      let boxWidthInCanvasUnits =
        (boundingBox[2] - boundingBox[0]) * widthRatio;

      rect = [
        boundingBox[0] * widthRatio - userBoxX * widthRatio,
        canvasHeight - boundingBox[3] * heightRatio + userBoxY * heightRatio,
        boxWidthInCanvasUnits,
        boxHeightInCanvasUnits,
      ];
    } else {
      let m: FzMatrix = initFzMatrix(
        tmx[0],
        tmx[1],
        tmx[2],
        tmx[3],
        tmx[4],
        tmx[5]
      );
      let r: FzRect = {
        x0: boundingBox[0],
        y0: boundingBox[1],
        x1: boundingBox[2],
        y1: boundingBox[3],
      };
      let transformedBBox = fz_transform_rect(r, m);

      let rectInCanvas = transformedBBox;

      rect = [
        rectInCanvas.x0 * widthRatio,
        rectInCanvas.y0 * heightRatio,
        (rectInCanvas.x1 - rectInCanvas.x0) * widthRatio,
        (rectInCanvas.y1 - rectInCanvas.y0) * heightRatio,
      ];
    }

    return rect;
  };

  /**
   * go to the page
   * @param pageNumber
   */
  const pdfGotoPage = (pageNumber: number) => {
    // linkService.pdfViewer.scrollPageIntoView({ pageNumber });
    PDFViewerApplication.pdfViewer.currentPageNumber = pageNumber;
  };

  /**
   *
   * @param e
   */
  const onTextLayerRendered = (e: any) => {
    if (!select_text) return;

    let pageNumber = e.pageNumber;

    // the rectangle canvas
    // then draw the rect
    let cnvsElem: any = document.querySelector(
      '[data-page-number="' + pageNumber + '"] > div.canvasWrapper > canvas'
    );
    _rawCanvases[pageNumber.toString()] = cloneCanvas(cnvsElem);
    if (pageNumber == getNormalizedPage()) {
      drawRectFromDetails();
    }
  };

  /**
   * wait till viewer is up, pages are loaded, and draw rect
   */
  const drawRect = (
    pdfWidth: number,
    pdfHeight: number,
    cropBox: Rect,
    mediaBox: Rect,
    boundingBox: Rect | Rect[],
    tmx: number[]
  ) => {
    // // then draw the rect
    let cnvsElem: any = document.querySelector(
      '[data-page-number="' +
        getNormalizedPage() +
        '"] > div.canvasWrapper > canvas'
    );
    let canvasCtx = cnvsElem.getContext("2d");

    // restore to clear canvas
    // draw
    canvasCtx.drawImage(_rawCanvases[getNormalizedPage().toString()], 0, 0);
    let rect1: number = 0;
    let rect0: number = 0;

    if (isArrayOfNumbers(boundingBox)) {
      let rect = [];

      rect = pdfBoxToCanvas(
        pdfWidth,
        pdfHeight,
        cropBox,
        mediaBox,
        boundingBox as Rect,
        cnvsElem.width,
        cnvsElem.height,
        tmx
      );

      // rectangle
      canvasCtx.fillStyle = highlight ? "#FFDD0055" : "rgba(255, 0, 0, 0)";
      canvasCtx.fillRect(...rect);
      rect1 = rect[1];
      rect0 = rect[0];
    } else {
      (boundingBox as Rect[]).forEach((box: Rect, index: number) => {
        let rect = [];
        rect = pdfBoxToCanvas(
          pdfWidth,
          pdfHeight,
          cropBox,
          mediaBox,
          box,
          cnvsElem.width,
          cnvsElem.height,
          tmx
        );

        // rectangle
        canvasCtx.fillStyle = highlight ? "#FFDD0055" : "rgba(255, 0, 0, 0)";
        canvasCtx.fillRect(...box);
        if (index == 0) {
          rect1 = rect[1];
          rect0 = rect[0];
        } else {
          if (rect1 < rect[1]) rect1 = rect[1];
          if (rect0 > rect[0]) rect0 = rect[0];
        }
      });
    }

    // scroll to it
    let cnvsWrapper: any = document.querySelector(
      '[data-page-number="' + getNormalizedPage() + '"] > div.canvasWrapper'
    );
    let cw = cnvsWrapper.clientWidth;
    let ch = cnvsWrapper.clientHeight;

    let elToScrollTo = document.createElement("div");
    elToScrollTo.style.position = "absolute";
    elToScrollTo.style.top = (rect1 / cnvsElem.height) * ch + "px";
    elToScrollTo.style.left = (rect0 / cnvsElem.width) * cw + "px";
    elToScrollTo.style.width = "200px";
    elToScrollTo.style.height = "100px";
    cnvsWrapper.appendChild(elToScrollTo);

    if (highlight)
      elToScrollTo.scrollIntoView({ behavior: "auto", block: "center" });
    // clean after you
    cnvsWrapper.removeChild(elToScrollTo);
  };

  /***
   * get next section details, build route, and go to that route
   */
  const playNext = async () => {
    const sectionDetailsUri =
      get_AI_URI_BASE() +
      `/api/getSectionDetails/company/${companyid}/kapp/${kappid}/doc/${docguid}/section/${nextSectionGuid}`;

    const nextSectionDetails = await axios(sectionDetailsUri, {
      headers: {
        Authorization: `Bearer ${jwtUserIdToken}`,
        "User-Id": userId,
        "Portal-Id": portalid,
      },
    });
    let nextSectionPageNumber = parseInt(
      nextSectionDetails.data[0]._source.action.pdfParams.pageNumber
    );

    if (nextSectionGuid) {
      (window as any).dispatchEvent(
        new CustomEvent("route-to", {
          detail: calcNextRoute(nextSectionPageNumber),
        })
      );
      (window as any).dispatchEvent(
        new CustomEvent("korra-next-section", {
          detail: {
            nextSectionPageNumber,
            nextSectionGuid,
          },
        })
      );
    }
  };

  const onDocDownload = (src: string, pdfDocument: any, setInDb: boolean) => {
    setDocumentLoaded(true);
    _eventBus.on(
      // other options:
      // pagesinit
      "documentinit",
      // "documentloaded",
      async (e: any) => {
        // console.log("doc loaded ");
      },
      { once: true }
    );

    /**
     * when document is loaded, save in local storage
     */
    _eventBus.on("documentloaded", async (event: any) => {
      (window as any).PDFViewerApplication._ensureDownloadComplete();

      const data = await (
        window as any
      ).PDFViewerApplication.pdfDocument.getData();

      getPdfFileCache().put(pdfSrcUrl.split("?")[0], data);
    });
  };

  // useEffect(() => {
  //   const i = setInterval(async () => {
  //     try {
  //       (window as any).PDFViewerApplication._ensureDownloadComplete();
  //       const data = await (
  //         window as any
  //       ).PDFViewerApplication.pdfDocument.getData();
  //       getPdfFileCache().put(pdfSrcUrl.split("?")[0], data);
  //       clearInterval(i);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   }, 500);
  //   return () => clearInterval(i);
  // }, []);

  /**
   *
   * @param src
   * @returns
   */
  const openPdf = async (src: string): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      try {
        initializedPromise().then(() => {
          (window as any).PDFViewerApplication.downloadComplete = false;
          (window as any).PDFViewerApplication.isViewerEmbedded = true;
          (window as any).PDFViewerApplication.loadingBar.percent = 0;
          (window as any).PDFViewerApplication.initialBookmark =
            "page=" + getNormalizedPage();
          // time the get
          // let getDocTime = Date.now();
          var documentData = getPdfFileCache().get(src.split("?")[0]);
          // console.log(`get doc time: ${Date.now() - getDocTime}`);

          if (documentData != null) {
            (window as any).PDFViewerApplication.open(documentData).then(
              (pdfDocument: any) => {
                return onDocDownload(src, pdfDocument, false);
              }
            );
          } else {
            (window as any).PDFViewerApplication.open(src).then(
              (pdfDocument: any) => {
                return onDocDownload(src, pdfDocument, true);
              }
            );
          }
        });
      } catch (ex) {
        reject(null);
      }
    });
  };

  /**
   * no download
   */
  useEffect(() => {
    // we dont want to download if there's a destination link
    if (fileRepositoryDestinationLink !== "") {
      return PDFViewerApplication.initializedPromise.then(() => {
        PDFViewerApplication.eventBus._listeners["download"] = [];
        return;
      });
    }
  }, [fileRepositoryDestinationLink]);
  /**
   *
   */
  const drawRectFromDetails = () => {
    if (!pageDetails) {
      return;
    }
    drawRect(
      pageDetails.data.Width,
      pageDetails.data.Height,
      pageDetails.data.boxes.CropBox,
      pageDetails.data.boxes.MediaBox,
      sectionDetails.data[0]._source.action.pdfParams.bounds,
      pageDetails.data.transform
    );

    setPlayNow(!playNowFT);
    setPlayNowFT(false);
  };

  /***
   * when document is loaded
   */
  useEffect(() => {
    if (!documentLoaded) {
      return;
    }

    const page = getNormalizedPage();

    logger.log({
      message: "PDF page loaded",
      portal_alias: portalAlias || alias.portalAlias,
      document_name: fileName || docguid,
      page_number: page,
    });

    pdfGotoPage(page);
  }, [documentLoaded]);

  /**
   * if section changed
   */
  useEffect(() => {
    if (!guid || !companyid || !kappid || !docguid) {
      return;
    }
    setPlayNow(false);
    // TODO: run the two calls in parallel, take section details from previous call
    const sectionDetailsUri =
      get_AI_URI_BASE() +
      `/api/getSectionDetails/company/${companyid}/kapp/${kappid}/doc/${docguid}/section/${guid}`;

    let sectionDetailsPromise = axios(sectionDetailsUri, {
      headers: {
        Authorization: `Bearer ${jwtUserIdToken}`,
        "User-Id": userId,
        "Portal-Id": portalid,
      },
    });
    Promise.all([sectionDetailsPromise]).then((dtls) => {
      dtls[0].data[0]._source.srcUrl = updateCdnUrlFromDotenv(
        removeMultipleSlashes(dtls[0].data[0]._source.srcUrl),
        isEdge
      );
      setSectionDetails(dtls[0]);
      (window as any).dispatchEvent(
        new CustomEvent("korra-file-name", {
          detail: dtls[0]?.data[0]._source?.srcUrl?.split("/").pop(),
        })
      );
    });
  }, [guid, companyid, kappid, docguid]);

  /**
   *
   */
  useEffect(() => {
    if (!sectionDetails || (!sasToken && !isEdge)) {
      return;
    }
    setPlayNow(false);
    setText(sectionDetails.data[0]._source.text);
    setNextSectionGuid(sectionDetails.data[0]._source.NextSectionGuid);
    if (isEdge) {
      (async () => {
        try {
          const edgeUser = await getEdgeUserLoginSession();
          const edgeSas = await getEdgeSassToken(edgeUser?.user.email);
          setPdfSrcUrl(
            sectionDetails.data[0]._source.srcUrl.replace(
              "/datadrive/localCDN",
              ""
            ) + `?sasToken=${edgeSas}`
          );
        } catch (error: any) {
          /** Error type */
          // general error
          console.error(error);
        }
      })();
    } else {
      if (!get_IS_CDN77()) {
        if (isEdge) {
          debugger;
          setPdfSrcUrl(
            sectionDetails.data[0]._source.srcUrl.replace(
              "/datadrive/localCDN",
              ""
            ) + `?sasToken=${auth.azureSasToken}`
          );
        } else if (sectionDetails.data[0]._source.srcUrl.startsWith("http")) {
          setPdfSrcUrl(
            sectionDetails.data[0]._source.srcUrl
              .replace(
                "https://1425625160.rsc.cdn77.org//assistants",
                get_CDN_BASE_URL()
              )
              .replace(
                "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net/",
                getCdnKorraBaseUrl()
              )
              .replace("/assistants/", "")
              .replace("#", "%23") + `?${sasToken}`
          );
        } else {
          let pdfUrl = get_CDN_BASE_URL() +
            "/" +
            sectionDetails.data[0]._source.srcUrl.replace("#", "%23");
          // remove duplicate production segments (with or without slash between)
          pdfUrl = pdfUrl.replace(/\/production\/?production\//g, '/production/');
          // remove any double slashes in the URL path
          pdfUrl = removeMultipleSlashes(pdfUrl);
          setPdfSrcUrl(pdfUrl + `?${sasToken}`);
        }
      } else {
        setPdfSrcUrl(sectionDetails.data[0]._source.srcUrl.replace("#", "%23"));
      }

      initializedPromise().then(() => {
        pdfGotoPage(getNormalizedPage());
      });

      (window as any).dispatchEvent(
        new CustomEvent("korra-file-name", {
          detail: sectionDetails.data[0]._source.srcUrl.split("/").pop(),
        })
      );

      sendEvent(
        companyid,
        kappid,
        portalid || "",
        alias.portalAlias || "",
        globals.sessionId || "",
        IKorraEventType.pdfRead,
        window.navigator.userAgent,
        isMobileOnly ? `mobile` : `desktop`,
        userId || "",
        {
          question: "", // ?
          answerText: sectionDetails.data[0]._source.text,
          answerLink: window.location.href,
          fileName: sectionDetails.data[0]._source.srcUrl,
          fileType: FileType.Pdf,
        } as IKorraEventDoc,
        globals.clientIp || ""
      );
    }
  }, [sectionDetails, sasToken]);

  /**
   * if page changed
   * */
  useEffect(() => {
    if (!companyid || !kappid || !docguid || page == undefined) {
      return;
    }
    // console.log(`page changed ${page}`);

    try {
      const pageDetailsUri =
        get_AI_URI_BASE() +
        `/api/getPageDetails/company/${companyid}/kapp/${kappid}/doc/${docguid}/page/${page}`;

      let pageDetailsPromise = axios(pageDetailsUri, {
        headers: {
          Authorization: `Bearer ${jwtUserIdToken}`,
          "User-Id": userId,
          "Portal-Id": portalid,
        },
      });
      Promise.all([pageDetailsPromise])
        .then((dtls) => {
          setPageDetails(dtls[0]);
        })
        .catch((error: any) => {
          // console.log(error);
          setPageDetails(null);
        });
    } catch (error) {
      logger.error({
        message: "Failed to fetch PDF page details",
        error: error,
        stacktrace: (error as any)?.stack,
        portal_alias: portalAlias || alias.portalAlias,
        document_name: fileName || docguid,
        page_number: page,
      });
    }
  }, [page, companyid, kappid, docguid]);

  useEffect(() => {
    // console.log(`page changed ${page}`);
    const fetchPrerequisites = async () => {
      if (!companyid || !kappid || !docguid) {
        return;
      }
      try {
        const prerequisitesDetailsUri =
          get_AI_URI_BASE() +
          `/prerequisites/workspace/${companyid}/kapp/${kappid}/doc/${docguid}`;

        const prerequisitesDetails = await axios(prerequisitesDetailsUri, {
          headers: {
            Authorization: `Bearer ${jwtUserIdToken}`,
            "User-Id": userId,
            "Portal-Id": portalid,
          },
        });
        setPrerequisitesConditions(prerequisitesDetails.data.texts);
        setPrerequisitesQueries(prerequisitesDetails.data.prerequisites);
      } catch (error) {
        logger.error({
          message: "Failed to fetch PDF prerequisites",
          error: error,
          stacktrace: (error as any)?.stack,
          portal_alias: portalAlias || alias.portalAlias,
          document_name: fileName || docguid,
        });
      }
    };
    fetchPrerequisites();
  }, [companyid, kappid, docguid]);

  const getNormalizedPage = () => {
    let pageNumberNormal = parseInt(page) + 1; //sectionDetails.data[0]._source.action.pdfParams.pageNumber) + 1;
    return pageNumberNormal;
  };

  const initializedPromise = () => {
    return new Promise<void>((resolve) => {
      return PDFViewerApplication.initializedPromise.then(() => {
        _eventBus = PDFViewerApplication.eventBus;
        return resolve();
      });
    });
  };

  const find = (query: string) => {
    _eventBus.dispatch("find", {
      query: query,
      caseSensitive: false,
      highlightAll: true,
      findPrevious: false,
      phraseSearch: true,
    });
    // _eventBus.on('updatefindmatchescount', (data: any) => {
    //   console.log("updatefindmatchescount", data);
    // });
  };

  const cleanDirectionalFormatting = (
    text: string,
    substring: string
  ): string => {
    return text.replace(/[\u202A\u202B\u202C\u202D\u202E]/g, substring);
  };

  const getSpanList = (): HTMLCollectionOf<HTMLSpanElement> => {
    let textLayers = document.getElementsByClassName("textLayer");
    let textLayer = textLayers[0];
    return textLayer.getElementsByTagName("span");
  };

  function levenshteinDistance(str1: string, str2: string) {
    const m = str1.length;
    const n = str2.length;
    const dp = new Array(m + 1).fill(null).map(() => new Array(n + 1).fill(0));

    for (let i = 0; i <= m; i++) {
      for (let j = 0; j <= n; j++) {
        if (i === 0) {
          dp[i][j] = j;
        } else if (j === 0) {
          dp[i][j] = i;
        } else {
          dp[i][j] = Math.min(
            dp[i - 1][j - 1] + (str1[i - 1] !== str2[j - 1] ? 1 : 0),
            dp[i - 1][j] + 1,
            dp[i][j - 1] + 1
          );
        }
      }
    }

    return dp[m][n];
  }

  function findFuzzyLongestSubstring(
    longString: string,
    shortString: string,
    threshold: number
  ) {
    let longestSubstring = "";

    for (let i = 0; i < shortString.length; i++) {
      for (let j = i + 1; j <= shortString.length; j++) {
        const substring = shortString.substring(i, j);

        for (let k = 0; k <= longString.length - substring.length; k++) {
          const longSubstring = longString.substring(k, k + substring.length);
          const distance = levenshteinDistance(substring, longSubstring);

          if (
            distance <= threshold &&
            substring.length > longestSubstring.length
          ) {
            longestSubstring = substring;
          }
        }
      }
    }

    return longestSubstring;
  }

  function findLongestSubstring(longString: string, shortString: string) {
    let longestSubstring = "";

    for (let i = 0; i < shortString.length; i++) {
      for (let j = i + 1; j <= shortString.length; j++) {
        const substring = shortString.substring(i, j);

        if (
          longString.includes(substring) &&
          substring.length > longestSubstring.length
        ) {
          longestSubstring = substring;
        }
      }
    }

    return longestSubstring;
  }

  // wait till the page arrives
  const localTextLayerRendered = (e: any) => {
    if (select_text) {
      let cnvsElem: any = document.querySelector(
        '[data-page-number="' + e.pageNumber + '"] > div.canvasWrapper > canvas'
      );
      _rawCanvases[e.pageNumber.toString()] = cnvsElem && cloneCanvas(cnvsElem);
      if (e.pageNumber == getNormalizedPage()) {
        // draw
        drawRectFromDetails();
      }
    }
  };
  /**
   * if the page or section details changed
   */
  useEffect(() => {
    if (!sectionDetails || (!pageDetails && !select_text) || !documentLoaded) {
      return;
    }
    setPlayNow(false);
    initializedPromise().then(() => {
      // if page arrived already
      if (_rawCanvases[getNormalizedPage().toString()]) {
        // console.log(
        //   "%c  page arrived already " + getNormalizedPage(),
        //   "background:#222; color: green;"
        // );
        drawRectFromDetails();
      } else {
        _eventBus.on("textlayerrendered", localTextLayerRendered);
      }
    });
  }, [pageDetails, sectionDetails, documentLoaded]);

  /**
   * src pdf changed
   */
  useEffect(() => {
    if (!pdfSrcUrl) {
      return;
    }
    (window as any).PDFViewerApplicationOptions.defaultUrl = "";

    if (isEdge) {
      setTimeout(() => {
        openPdf(pdfSrcUrl);
      }, 1000);
    } else {
      openPdf(pdfSrcUrl);
    }
    setDocumentLanguage(pdfSrcUrl?.includes("---JA") ? "ja-JP" : "en");
    _rawCanvases = {};
  }, [pdfSrcUrl]);

  /***
   * component constructor []
   */
  useEffect(() => {
    setPlayNowFT(true);
    // needed for the web-component - problem with preact
    let interval = setInterval(() => {
      if (document.getElementById("viewerContainer")) {
        setWindowLoaded(true);

        clearInterval(interval);
      }
    }, 255);

    // set pdfjs stuff
    try {
      ((window as any).PDFViewerApplicationOptions as any).set(
        "workerSrc",
        get_APP_URI_BASE() + "/assets/pdfjs/minified/build/pdf.worker.js"
      );
      ((window as any).PDFViewerApplicationOptions as any).set(
        "standardFontDataUrl",
        get_APP_URI_BASE() + "/assets/pdfjs/minified/web/standard_fonts/"
      );
      ((window as any).PDFViewerApplicationOptions as any).set(
        "cMapUrl",
        get_APP_URI_BASE() + "/assets/pdfjs/minified/web/cmaps/"
      );
      if (!!options) {
        setOptionsObj(JSON.parse(options));
      }
    } catch (error) {
      logger.error({
        message: "PDF.js initialization error",
        error: error,
        stacktrace: (error as any)?.stack,
        portal_alias: portalAlias || alias.portalAlias,
        document_name: fileName || docguid,
      });
    }

    // if mic clicked, stop
    const micClicked = () => {
      setPlayNow(false);
    };

    return () => {
      // unmount code
      // console.log("unmount pdf viewer component");
      _eventBus && _eventBus.off("textlayerrendered", onTextLayerRendered);

      _eventBus && _eventBus.off("textlayerrendered", localTextLayerRendered);
      setCanvas(null);
    };
  }, []);

  /**
   * on play pause reading
   */
  const onWheel = () => {
    setPlayNow(false);
  };

  /**
   * windows fully loaded
   */
  useEffect(() => {
    if (windowFullyLoaded) {
      let viewerContainer = document.getElementById("viewerContainer");
      if (viewerContainer !== null) {
        const container = viewerContainer;
        container.style.position = "absolute";
      } else {
        logger.error({
          message: "PDF viewer container element not found",
          portal_alias: portalAlias || alias.portalAlias,
          document_name: fileName || docguid,
          element_id: "viewerContainer",
        });
      }
      /*
      //container.style.top = "132px";
      container.style.top = "0";
      container.style.left = "0";
      container.style.width = "100%";
      //container.style.height = "calc(100vh - 264px)";
      container.style.height = "calc(100vh - 132px)";
       * */

      // console.log(
      //   "window fully loaded ",
      //   viewerContainer?.offsetWidth,
      //   viewerContainer?.offsetHeight
      // );

      // start the loading process
      (window as any).webViewerLoad();
      initializedPromise().then(() => {
        _eventBus.on("textlayerrendered", onTextLayerRendered);
        _eventBus.on("pagechanging", function pagechange(evt: any) {
          // console.log("pagechanging to " + evt.pageNumber);
          // (window as any).dispatchEvent(
          //   new CustomEvent("route-to", {
          //         detail: calcNextRoute(evt.pageNumber),
          //     }
          //   )
          // );
        });

        (window as any).PDFViewerApplicationOptions.defaultUrl = "";
      });
      return () => {};
    }
  }, [windowFullyLoaded]);

  return (
    <div onWheel={onWheel} onTouchMove={onWheel} id="outerContainer">
      {/* make sure that the flag is true and also that we recevied prerequisites  */}
      {appearance.showRelatedDocuments &&
        prerequisitesConditions.length > 0 &&
        prerequisitesQueries.length > 0 && (
          <PrerequisitesBox
            workspaceAlias={workspaceAlias}
            portalAlias={portalAlias}
            prerequisitesQueries={prerequisitesQueries}
            prerequisitesConditions={prerequisitesConditions}
          />
        )}

      <div id="sidebarContainer" style="display:none;">
        <div id="toolbarSidebar">
          <div id="toolbarSidebarLeft">
            {/* <div className={`${viewerStyles.splitToolbarButton} ${viewerStyles.toggled}`}> */}
            <div>
              <button
                id="viewThumbnail"
                className="toolbarButton toggled"
                title="Show Thumbnails"
                data-l10n-id="thumbs"
              >
                <span data-l10n-id="thumbs_label">Thumbnails</span>
              </button>
              <button
                id="viewOutline"
                className="toolbarButton"
                title="Show Document Outline (double-click to expand/collapse all items)"
                data-l10n-id="document_outline"
              >
                <span data-l10n-id="document_outline_label">
                  Document Outline
                </span>
              </button>
              <button
                id="viewAttachments"
                className="toolbarButton"
                title="Show Attachments"
                data-l10n-id="attachments"
              >
                <span data-l10n-id="attachments_label">Attachments</span>
              </button>
              <button
                id="viewLayers"
                className="toolbarButton"
                title="Show Layers (double-click to reset all layers to the default state:any)"
                data-l10n-id="layers"
              >
                <span data-l10n-id="layers_label">Layers</span>
              </button>
            </div>
          </div>

          <div id="toolbarSidebarRight">
            <div id="outlineOptionsContainer" className="hidden">
              <div className="verticalToolbarSeparator"></div>

              <button
                id="currentOutlineItem"
                className="toolbarButton"
                disabled={true}
                title="Find Current Outline Item"
                data-l10n-id="current_outline_item"
              >
                <span data-l10n-id="current_outline_item_label">
                  Current Outline Item
                </span>
              </button>
            </div>
          </div>
        </div>
        <div id="sidebarContent">
          <div id="thumbnailView"></div>
          <div id="outlineView" className="hidden"></div>
          <div id="attachmentsView" className="hidden"></div>
          <div id="layersView" className="hidden"></div>
        </div>
        <div id="sidebarResizer"></div>
      </div>

      <div
        id={
          isMobileOnly
            ? "mainContainer"
            : mode === "widget"
            ? "mainContainerWidget"
            : "mainContainerDesktop"
        }
        //className={optionsObj?.explanator && "gptContainer"}
        className={!appearance.hideFileName ? "gptContainer" : ""}
        style={{
          top: "50px",
        }}
      >
        {!appearance.hideFileName && (
          <div className={styles.fileNameContainer}>
            <span
              className={styles.fileNameLabel}
              style={{ textAlign: isMobileOnly ? "start" : "" }}
              title={fileName}
            >
              {fileName !== "undefined"
                ? fileName
                    ?.replace(new RegExp("%20", "g"), " ")
                    ?.replace(new RegExp("--HE.pdf", "g"), "מסמך")
                : ""}
            </span>
          </div>
        )}
        <div className="findbar hidden doorHanger" id="findbar">
          <div id="findbarInputContainer">
            <input
              id="findInput"
              className="toolbarField"
              title="Find"
              placeholder="Find in document"
              data-l10n-id="find_input"
            />
            <div className="splitToolbarButton">
              <button
                id="findPrevious"
                className="toolbarButton findPrevious"
                title="Find the previous occurrence of the phrase"
                data-l10n-id="find_previous"
              >
                <span data-l10n-id="find_previous_label">Previous</span>
              </button>
              <div className="splitToolbarButtonSeparator"></div>
              <button
                id="findNext"
                className="toolbarButton findNext"
                title="Find the next occurrence of the phrase"
                data-l10n-id="find_next"
              >
                <span data-l10n-id="find_next_label">Next</span>
              </button>
            </div>
          </div>

          <div id="findbarOptionsOneContainer">
            <input
              type="checkbox"
              id="findHighlightAll"
              className="toolbarField"
            />
            <label
              for="findHighlightAll"
              className="toolbarLabel"
              // data-l10n-id="find_highlight"
            >
              Highlight all
            </label>
            <input
              type="checkbox"
              id="findMatchCase"
              className="toolbarField"
            />
            <label
              for="findMatchCase"
              className="toolbarLabel"
              // data-l10n-id="find_match_case_label"
            >
              Match case
            </label>
          </div>
          <div id="findbarOptionsTwoContainer">
            <input
              type="checkbox"
              id="findMatchDiacritics"
              class="toolbarField"
            />
            <label
              for="findMatchDiacritics"
              class="toolbarLabel"
              // data-l10n-id="find_match_diacritics_label"
            >
              Match Diacritics
            </label>
            <input
              type="checkbox"
              id="findEntireWord"
              className="toolbarField"
            />
            <label
              for="findEntireWord"
              className="toolbarLabel"
              // data-l10n-id="find_entire_word_label"
            >
              Whole words
            </label>
            <span id="findResultsCount" className="toolbarLabel hidden"></span>
          </div>

          <div id="findbarMessageContainer">
            <span id="findMsg" className="toolbarLabel"></span>
          </div>
        </div>

        <div
          id="secondaryToolbar"
          className="secondaryToolbar hidden doorHangerRight"
        >
          <div id="secondaryToolbarButtonContainer">
            <button
              id="secondaryPresentationMode"
              className="secondaryToolbarButton presentationMode visibleLargeView"
              title="Switch to Presentation Mode"
              data-l10n-id="presentation_mode"
              style={{ display: isEdge ? "none" : "block" }}
            >
              <span data-l10n-id="presentation_mode_label">
                Presentation Mode
              </span>
            </button>

            <button
              id="secondaryOpenFile"
              className="secondaryToolbarButton openFile visibleLargeView"
              title="Open File"
              data-l10n-id="open_file"
              style={{ display: "none" }}
            >
              <span data-l10n-id="open_file_label">Open</span>
            </button>

            <button
              id="secondaryPrint"
              className="secondaryToolbarButton print visibleMediumView"
              title="Print"
              data-l10n-id="print"
              style={{ display: "none" }}
            >
              <span data-l10n-id="print_label">Print</span>
            </button>

            <button
              id="secondaryDownload"
              className="secondaryToolbarButton download visibleMediumView"
              title="Download"
              data-l10n-id="download"
              style={{ display: isEdge ? "none" : "block" }}
            >
              <span data-l10n-id="download_label">Download</span>
            </button>

            <a
              href="#"
              id="secondaryViewBookmark"
              className="secondaryToolbarButton bookmark visibleSmallView"
              title="Current view (copy or open in new window)"
              data-l10n-id="bookmark"
            >
              <span data-l10n-id="bookmark_label">Current View</span>
            </a>

            <div className="horizontalToolbarSeparator visibleLargeView"></div>

            <button
              id="firstPage"
              className="secondaryToolbarButton firstPage"
              title="Go to First Page"
              data-l10n-id="first_page"
            >
              <span data-l10n-id="first_page_label">Go to First Page</span>
            </button>
            <button
              id="lastPage"
              className="secondaryToolbarButton lastPage"
              title="Go to Last Page"
              data-l10n-id="last_page"
            >
              <span data-l10n-id="last_page_label">Go to Last Page</span>
            </button>

            <div className="horizontalToolbarSeparator"></div>

            <button
              id="pageRotateCw"
              className="secondaryToolbarButton rotateCw"
              title="Rotate Clockwise"
              data-l10n-id="page_rotate_cw"
            >
              <span data-l10n-id="page_rotate_cw_label">Rotate Clockwise</span>
            </button>
            <button
              id="pageRotateCcw"
              className="secondaryToolbarButton rotateCcw"
              title="Rotate Counterclockwise"
              data-l10n-id="page_rotate_ccw"
            >
              <span data-l10n-id="page_rotate_ccw_label">
                Rotate Counterclockwise
              </span>
            </button>

            <div className="horizontalToolbarSeparator"></div>

            <button
              id="cursorSelectTool"
              className="secondaryToolbarButton selectTool toggled"
              title="Enable Text Selection Tool"
              data-l10n-id="cursor_text_select_tool"
            >
              <span data-l10n-id="cursor_text_select_tool_label">
                Text Selection Tool
              </span>
            </button>
            <button
              id="cursorHandTool"
              className="secondaryToolbarButton handTool"
              title="Enable Hand Tool"
              data-l10n-id="cursor_hand_tool"
            >
              <span data-l10n-id="cursor_hand_tool_label">Hand Tool</span>
            </button>

            <div className="horizontalToolbarSeparator"></div>

            <button
              id="scrollPage"
              className="secondaryToolbarButton scrollPage"
              title="Use Page Scrolling"
              data-l10n-id="scroll_page"
            >
              <span data-l10n-id="scroll_page_label">Page Scrolling</span>
            </button>
            <button
              id="scrollVertical"
              className="secondaryToolbarButton scrollVertical toggled"
              title="Use Vertical Scrolling"
              data-l10n-id="scroll_vertical"
            >
              <span data-l10n-id="scroll_vertical_label">
                Vertical Scrolling
              </span>
            </button>
            <button
              id="scrollHorizontal"
              className="secondaryToolbarButton scrollHorizontal"
              title="Use Horizontal Scrolling"
              data-l10n-id="scroll_horizontal"
            >
              <span data-l10n-id="scroll_horizontal_label">
                Horizontal Scrolling
              </span>
            </button>
            <button
              id="scrollWrapped"
              className="secondaryToolbarButton scrollWrapped"
              title="Use Wrapped Scrolling"
              data-l10n-id="scroll_wrapped"
            >
              <span data-l10n-id="scroll_wrapped_label">Wrapped Scrolling</span>
            </button>

            <div className="horizontalToolbarSeparator"></div>

            <button
              id="spreadNone"
              className="secondaryToolbarButton spreadNone toggled"
              title="Do not join page spreads"
              data-l10n-id="spread_none"
            >
              <span data-l10n-id="spread_none_label">No Spreads</span>
            </button>
            <button
              id="spreadOdd"
              className="secondaryToolbarButton spreadOdd"
              title="Join page spreads starting with odd-numbered pages"
              data-l10n-id="spread_odd"
            >
              <span data-l10n-id="spread_odd_label">Odd Spreads</span>
            </button>
            <button
              id="spreadEven"
              className="secondaryToolbarButton spreadEven"
              title="Join page spreads starting with even-numbered pages"
              data-l10n-id="spread_even"
            >
              <span data-l10n-id="spread_even_label">Even Spreads</span>
            </button>

            <div className="horizontalToolbarSeparator"></div>

            <button
              id="documentProperties"
              className="secondaryToolbarButton documentProperties"
              title="Document Properties"
              data-l10n-id="document_properties"
            >
              <span data-l10n-id="document_properties_label">
                Document Properties
              </span>
            </button>
          </div>
        </div>

        <div className="toolbar">
          <div id="toolbarContainer">
            <div id="toolbarViewer">
              <div id="toolbarViewerLeft">
                <button
                  id="sidebarToggle"
                  className="toolbarButton"
                  title="Toggle Sidebar"
                  data-l10n-id="toggle_sidebar"
                  aria-expanded="false"
                  aria-controls="sidebarContainer"
                >
                  <span data-l10n-id="toggle_sidebar_label">
                    Toggle Sidebar
                  </span>
                </button>
                <div className="toolbarButtonSpacer"></div>
                <button
                  id="viewFind"
                  className="toolbarButton"
                  title="Find in Document"
                  data-l10n-id="findbar"
                  aria-expanded="false"
                  aria-controls="findbar"
                >
                  <span data-l10n-id="findbar_label">Find</span>
                </button>
                <div className="splitToolbarButton hiddenSmallView">
                  <button
                    className="toolbarButton pageUp"
                    title="Previous Page"
                    id="previous"
                    data-l10n-id="previous"
                  >
                    <span data-l10n-id="previous_label">Previous</span>
                  </button>
                  <div className="splitToolbarButtonSeparator"></div>
                  <button
                    className="toolbarButton pageDown"
                    title="Next Page"
                    id="next"
                    data-l10n-id="next"
                  >
                    <span data-l10n-id="next_label">Next</span>
                  </button>
                </div>
                <input
                  type="number"
                  id="pageNumber"
                  className="toolbarField pageNumber"
                  title="Page"
                  value={parseInt(page) + 1}
                  size={4}
                  min="1"
                  data-l10n-id="page"
                  autocomplete="off"
                />
                <span id="numPages" className="toolbarLabel"></span>
              </div>
              <div id="toolbarViewerRight">
                <button
                  id="presentationMode"
                  className="toolbarButton presentationMode hiddenLargeView"
                  title="Switch to Presentation Mode"
                  data-l10n-id="presentation_mode"
                  style={{ display: isEdge ? "none" : "block" }}
                >
                  <span data-l10n-id="presentation_mode_label">
                    Presentation Mode
                  </span>
                </button>

                <button
                  id="openFile"
                  className="toolbarButton openFile hiddenLargeView"
                  title="Open File"
                  data-l10n-id="open_file"
                  style={{ display: "none" }}
                >
                  <span data-l10n-id="open_file_label">Open</span>
                </button>

                <button
                  id="print"
                  className="toolbarButton print hiddenMediumView"
                  title="Print"
                  data-l10n-id="print"
                  style={{ display: "none" }}
                >
                  <span data-l10n-id="print_label">Print</span>
                </button>

                {enableFileRepositoryDestinationLink &&
                fileRepositoryDestinationLink?.startsWith("http") ? (
                  <span className={styles.hiddenMediumView}>
                    <button
                      className={`toolbarButton hiddenMediumView  ${styles.downloadButton}`}
                      title="Download"
                      onClick={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (fileRepositoryDestinationLink)
                          window.open(
                            fileRepositoryDestinationLink.startsWith("http")
                              ? fileRepositoryDestinationLink
                              : `https://${fileRepositoryDestinationLink}`,
                            "_blank"
                          );
                      }}
                      style={{ display: isEdge ? "none" : "block" }}
                    >
                      <span>Download</span>
                    </button>
                  </span>
                ) : (
                  <button
                    // id="secondaryDownload"
                    id="download"
                    className="toolbarButton download"
                    title="Download"
                    data-l10n-id="download"
                    aria-expanded="false"
                    aria-controls="secondaryToolbar"
                    style={{
                      display: isEdge
                        ? "none"
                        : enableFileRepositoryDestinationLink
                        ? "none"
                        : "block",
                    }}
                  >
                    <span data-l10n-id="download_label">Download</span>
                  </button>
                )}

                <a
                  href="#"
                  id="viewBookmark"
                  className="toolbarButton bookmark hiddenSmallView"
                  title="Current view (copy or open in new window)"
                  data-l10n-id="bookmark"
                >
                  <span data-l10n-id="bookmark_label">Current View</span>
                </a>

                <div className="verticalToolbarSeparator hiddenSmallView"></div>

                {/* <button
                  id="secondaryDownload"
                  className="toolbarButton visibleLargeView"
                  title="Download"
                  data-l10n-id="download"
                  aria-expanded="false"
                  aria-controls="secondaryToolbar"
                >
                  <span data-l10n-id="download_label">Download</span>
                </button> */}

                <button
                  id="secondaryToolbarToggle"
                  className="toolbarButton hiddenSmallView hiddenMediumView visibleLargeView"
                  title="Tools"
                  data-l10n-id="tools"
                  aria-expanded="false"
                  aria-controls="secondaryToolbar"
                >
                  <span data-l10n-id="tools_label">Tools</span>
                </button>
              </div>
              <div id="toolbarViewerMiddle">
                <div className="splitToolbarButton">
                  <button
                    id="zoomOut"
                    className="toolbarButton zoomOut"
                    title="Zoom Out"
                    data-l10n-id="zoom_out"
                  >
                    <span data-l10n-id="zoom_out_label">Zoom Out</span>
                  </button>
                  <div className="splitToolbarButtonSeparator"></div>
                  <button
                    id="zoomIn"
                    className="toolbarButton zoomIn"
                    title="Zoom In"
                    data-l10n-id="zoom_in"
                  >
                    <span data-l10n-id="zoom_in_label">Zoom In</span>
                  </button>
                </div>
                <span
                  id="scaleSelectContainer"
                  className="dropdownToolbarButton"
                >
                  <select
                    id="scaleSelect"
                    title="Zoom"
                    data-l10n-id="zoom"
                    ref={selectRef}
                  >
                    <option
                      id="pageAutoOption"
                      title=""
                      value="auto"
                      // data-l10n-id="page_scale_auto"
                    >
                      Automatic Zoom
                    </option>
                    <option
                      id="pageActualOption"
                      title=""
                      value="page-actual"
                      // data-l10n-id="page_scale_actual"
                    >
                      Actual Size
                    </option>
                    <option
                      id="pageFitOption"
                      title=""
                      value="page-fit"
                      // data-l10n-id="page_scale_fit"
                    >
                      Page Fit
                    </option>
                    <option
                      id="pageWidthOption"
                      title=""
                      value="page-width"
                      selected={true}
                      // data-l10n-id="page_scale_width"
                    >
                      Page Width
                    </option>
                    <option
                      id="customScaleOption"
                      title=""
                      value="custom"
                      disabled={true}
                      hidden={true}
                    ></option>
                    <option
                      title=""
                      value="0.5"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 50 }'
                    >
                      50%
                    </option>
                    <option
                      title=""
                      value="0.75"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 75 }'
                    >
                      75%
                    </option>
                    <option
                      title=""
                      value="1"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 100 }'
                    >
                      100%
                    </option>
                    <option
                      title=""
                      value="1.25"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 125 }'
                    >
                      125%
                    </option>
                    <option
                      title=""
                      value="1.5"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 150 }'
                    >
                      150%
                    </option>
                    <option
                      title=""
                      value="2"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 200 }'
                    >
                      200%
                    </option>
                    <option
                      title=""
                      value="3"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 300 }'
                    >
                      300%
                    </option>
                    <option
                      title=""
                      value="4"
                      // data-l10n-id="page_scale_percent"
                      data-l10n-args='{ "scale": 400 }'
                    >
                      400%
                    </option>
                  </select>
                </span>
              </div>
            </div>
            <div id="loadingBar">
              <div className="progress">
                <div className="glimmer"></div>
              </div>
            </div>
          </div>
        </div>

        <div id="viewerContainer" className={styles.calcWidthOnMobile}>
          <div id="viewer" className="pdfViewer"></div>
        </div>

        <div id="errorWrapper" hidden={true}>
          <div id="errorMessageLeft">
            <span id="errorMessage"></span>
            <button id="errorShowMore" data-l10n-id="error_more_info">
              More Information
            </button>
            <button
              id="errorShowLess"
              data-l10n-id="error_less_info"
              hidden={true}
            >
              Less Information
            </button>
          </div>
          <div id="errorMessageRight">
            <button id="errorClose" data-l10n-id="error_close">
              Close
            </button>
          </div>
          <div className="clearBoth"></div>
          <textarea id="errorMoreInfo" hidden={true} readonly={true}></textarea>
        </div>
      </div>

      <div id="dialogContainer">
        <dialog id="passwordDialog">
          <div className="row">
            <label
              for="password"
              id="passwordText"
              data-l10n-id="password_label"
            >
              Enter the password to open this PDF file:
            </label>
          </div>
          <div className="row">
            <input type="password" id="password" className="toolbarField" />
          </div>
          <div className="buttonRow">
            <button id="passwordCancel" className="dialogButton">
              <span data-l10n-id="password_cancel">Cancel</span>
            </button>
            <button id="passwordSubmit" className="dialogButton">
              <span data-l10n-id="password_ok">OK</span>
            </button>
          </div>
        </dialog>
        <dialog id="documentPropertiesDialog">
          <div className="row">
            <span
              id="fileNameLabel"
              data-l10n-id="document_properties_file_name"
            >
              File name:
            </span>
            <p id="fileNameField" aria-labelledby="fileNameLabel">
              -
            </p>
          </div>
          <div className="row">
            <span
              id="fileSizeLabel"
              data-l10n-id="document_properties_file_size"
            >
              File size:
            </span>
            <p id="fileSizeField" aria-labelledby="fileSizeLabel">
              -
            </p>
          </div>
          <div className="separator"></div>
          <div className="row">
            <span id="titleLabel" data-l10n-id="document_properties_title">
              Title:
            </span>
            <p id="titleField" aria-labelledby="titleLabel">
              -
            </p>
          </div>
          <div className="row">
            <span id="authorLabel" data-l10n-id="document_properties_author">
              Author:
            </span>
            <p id="authorField" aria-labelledby="authorLabel">
              -
            </p>
          </div>
          <div className="row">
            <span id="subjectLabel" data-l10n-id="document_properties_subject">
              Subject:
            </span>
            <p id="subjectField" aria-labelledby="subjectLabel">
              -
            </p>
          </div>
          <div className="row">
            <span
              id="keywordsLabel"
              data-l10n-id="document_properties_keywords"
            >
              Keywords:
            </span>
            <p id="keywordsField" aria-labelledby="keywordsLabel">
              -
            </p>
          </div>
          <div className="row">
            <span
              id="creationDateLabel"
              data-l10n-id="document_properties_creation_date"
            >
              Creation Date:
            </span>
            <p id="creationDateField" aria-labelledby="creationDateLabel">
              -
            </p>
          </div>
          <div className="row">
            <span
              id="modificationDateLabel"
              data-l10n-id="document_properties_modification_date"
            >
              Modification Date:
            </span>
            <p
              id="modificationDateField"
              aria-labelledby="modificationDateLabel"
            >
              -
            </p>
          </div>
          <div className="row">
            <span id="creatorLabel" data-l10n-id="document_properties_creator">
              Creator:
            </span>
            <p id="creatorField" aria-labelledby="creatorLabel">
              -
            </p>
          </div>
          <div className="separator"></div>
          <div className="row">
            <span
              id="producerLabel"
              data-l10n-id="document_properties_producer"
            >
              PDF Producer:
            </span>
            <p id="producerField" aria-labelledby="producerLabel">
              -
            </p>
          </div>
          <div className="row">
            <span id="versionLabel" data-l10n-id="document_properties_version">
              PDF Version:
            </span>
            <p id="versionField" aria-labelledby="versionLabel">
              -
            </p>
          </div>
          <div className="row">
            <span
              id="pageCountLabel"
              data-l10n-id="document_properties_page_count"
            >
              Page Count:
            </span>
            <p id="pageCountField" aria-labelledby="pageCountLabel">
              -
            </p>
          </div>
          <div className="row">
            <span
              id="pageSizeLabel"
              data-l10n-id="document_properties_page_size"
            >
              Page Size:
            </span>
            <p id="pageSizeField" aria-labelledby="pageSizeLabel">
              -
            </p>
          </div>
          <div className="separator"></div>
          <div className="row">
            <span
              id="linearizedLabel"
              data-l10n-id="document_properties_linearized"
            >
              Fast Web View:
            </span>
            <p id="linearizedField" aria-labelledby="linearizedLabel">
              -
            </p>
          </div>
          <div className="buttonRow">
            <button id="documentPropertiesClose" className="dialogButton">
              <span data-l10n-id="document_properties_close">Close</span>
            </button>
          </div>
        </dialog>
      </div>

      <div id="printContainer"></div>
    </div>
  );
};

export default KorraPdfViewer;
